import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "league-breadcrumbs"
}
const _hoisted_2 = { key: 1 }

import isNil from 'lodash/isNil'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import i18n from '@/i18n'
import { useLeaguesStore } from '@/store/public/leagues'

interface LeagueBreadcrumbsItem {
  label: string
  path?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LeagueBreadcrumbs',
  setup(__props) {

const leagues = useLeaguesStore()
const route = useRoute()

const items = computed<LeagueBreadcrumbsItem[]>((): LeagueBreadcrumbsItem[] => {
  const items = []

  items.push({
    label: i18n.global.t('leagues.labels.all-seasons'),
    path: '/leagues',
  })

  if (!isNil(leagues.selectedSeason)) {
    items.push({
      label: leagues.selectedSeason,
      path: `/leagues/${leagues.selectedSeason}`,
    })
  }

  if (!isNil(leagues.selectedSeason) && !isNil(leagues.selectedLeague)) {
    items.push({
      label: leagues.selectedLeague?.name,
      path: `/leagues/${leagues.selectedSeason}/${leagues.selectedLeague?.id}`,
    })
  }

  if (
    !isNil(leagues.selectedSeason) &&
    !isNil(leagues.selectedLeague) &&
    !isNil(leagues.selectedRound)
  ) {
    const section = isNil(leagues.selectedRound?.section_number_extra)
      ? String(leagues.selectedRound?.section_number)
      : `${leagues.selectedRound?.section_number} / ${leagues.selectedRound?.section_number_extra}`

    items.push({
      label: i18n.global.t('leagues.labels.section-round', {
        section,
        separator: '-',
        round: String(leagues.selectedRound?.number),
      }),
      path: `/leagues/${leagues.selectedSeason}/${leagues.selectedLeague?.id}/standings/${leagues.selectedRound?.id}`,
    })
  }

  if (
    !isNil(leagues.selectedSeason) &&
    !isNil(leagues.selectedLeague) &&
    !isNil(leagues.selectedRound) &&
    !isNil(leagues.selectedMatch)
  ) {
    items.push({
      label: `${leagues.selectedMatch?.standings?.home_team?.name} - ${leagues.selectedMatch?.standings?.away_team?.name}`,
      path: `/leagues/${leagues.selectedSeason}/${leagues.selectedLeague?.id}/standings/${leagues.selectedRound?.id}/${leagues.selectedMatch?.id}`,
    })
  }

  if (!isNil(route.meta.breadcrumbLabel)) {
    items.push({
      label: route.meta.breadcrumbLabel as string,
    })
  }

  return items
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (items.value.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `item-${i}`,
            class: "league-breadcrumbs-item"
          }, [
            (!_unref(isNil)(item.path))
              ? (_openBlock(), _createBlock(_component_RouterLink, {
                  key: 0,
                  to: { path: item.path }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.label), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.label), 1))
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})